"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindStorePage = FindStorePage;
var jsx_runtime_1 = require("react/jsx-runtime");
function FindStorePage() {
    return (0, jsx_runtime_1.jsx)("div", { children: "Find Store Page" });
}
